import React from 'react';
import styled from 'styled-components';
import { IoAccessibilityOutline } from '@react-icons/all-files/io5/IoAccessibilityOutline';
import { IoBulbOutline } from '@react-icons/all-files/io5/IoBulbOutline';
import { IoChatbubbleOutline } from '@react-icons/all-files/io5/IoChatbubbleOutline';
import { IoCloudOutline } from '@react-icons/all-files/io5/IoCloudOutline';
import { IoHeartOutline } from '@react-icons/all-files/io5/IoHeartOutline';
import { IoLaptopOutline } from '@react-icons/all-files/io5/IoLaptopOutline';
import { IoMapOutline } from '@react-icons/all-files/io5/IoMapOutline';
import { IoPaperPlaneOutline } from '@react-icons/all-files/io5/IoPaperPlaneOutline';
import { IoSpeedometerOutline } from '@react-icons/all-files/io5/IoSpeedometerOutline';
import { prepareComponent } from '@bluframe/grapple';

const Icon$1 = styled.span.withConfig({
  displayName: "styled__Icon",
  componentId: "sc-ztr6p6-0"
})(["& svg{color:", ";}"], ({
  theme
}) => theme.palette.primary.main);

const Icon = ({
  color,
  SelectedIcon,
  size
}) => /*#__PURE__*/React.createElement(Icon$1, null, /*#__PURE__*/React.createElement(SelectedIcon, {
  color: color,
  size: size
}));

const ionIcons = Object.freeze({
  accessibilityOutline: IoAccessibilityOutline,
  bulbOutline: IoBulbOutline,
  chatBubbleOutline: IoChatbubbleOutline,
  cloudOutline: IoCloudOutline,
  heartOutline: IoHeartOutline,
  laptopOutline: IoLaptopOutline,
  mapOutline: IoMapOutline,
  paperPlaneOutline: IoPaperPlaneOutline,
  speedometerOutline: IoSpeedometerOutline
});

const usePrepareComponent = ({
  color,
  group,
  name,
  size
}) => {
  if (group === "ion" && ionIcons[name]) {
    return {
      SelectedIcon: ionIcons[name],
      color,
      size
    };
  }

  return {
    SelectedIcon: () => null,
    color,
    size
  };
};

var index = prepareComponent(usePrepareComponent)(Icon);

export { index as default };
